import styled, { keyframes } from "styled-components"
import signInBackgroundImage from "../../assets/sign-in-background.jpg"

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: stretch;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 700px;
`

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  animation: ${appearFromLeft} 1s;

  form {
    margin: 50px 0;
    width: 340px;

    text-align: center;

    display: flex;
    flex-direction: column;
    gap: 8px;

    h1 {
      margin-bottom: 24px;
    }

    button {
      background-color: ${(props) => props.theme.colors.primaryBlue};
    }
  }
`

export const Background = styled.div`
  flex: 1;
  background: url(${signInBackgroundImage}) no-repeat center;
  background-size: cover;
`
